import Api from '@/services/Api';

export default {
	async matchingPropertiesByStage(obj) {
		return await Api.post('/api/matching-properties-by-stage', obj);
	},
	async getProperties(obj) {
		return await Api.post('/api/properties', obj);
	},
	async getCommercialProperties(obj) {
		// TODO: revisit this when implementation is done
		return await Api.post(`/api/properties/commercial?page=${obj?.page || 1}`, obj);
	},
	async getMapMarkers(obj) {
		return await Api.post('/api/properties/map-markers', obj);
	},
	async getProperty(id) {
		return await Api.get(`/api/property/${id}`);
	},
	async getUnpersonalizedPdf(id) {
		return await Api.get(`/api/property/unpersonalized-pdf/${id}`);
	},
	async getDeletedProperty(id) {
		return await Api.get(`/api/property/deleted/${id}`);
	},
	async dropDownOptions(obj) {
		return await Api.post('api/get-dropdown-options', obj);
	},
	async updateProperty(property) {
		if (property.id) {
			return await Api.patch(`/api/property/${property.id}`, property);
		}

		return await Api.post('/api/property', property);
	},
	async deleteProperty(id) {
		return await Api.delete('/api/property', { data: { property_id: id } });
	},
	async getDeletedProperties(obj) {
		return await Api.post('/api/properties/deleted', obj);
	},
	async getDraftsProperties(obj) {
		return await Api.post('/api/properties/drafts', obj);
	},
	async restoreProperty(id) {
		return await Api.patch('/api/property/restore', { property_id: id });
	},
	async destroyProperty(id) {
		return await Api.delete('/api/property/destroy', { data: { property_id: id } });
	},
	async getSortedDeletedProperties(obj) {
		return await Api.get(`/api/properties/deleted?order_by=${obj.order_by}&order=${obj.order}&page=${obj.page}`, obj);
	},
	async getSortedDraftsProperties(obj) {
		return await Api.post(`/api/properties/drafts?order_by=${obj.order_by}&order=${obj.order}&page=${obj.page}`, obj);
	},
	// Matching customers
	async matchingProperties(obj) {
		return await Api.post('/api/property-match', obj);
	},
	// Assign property to stage
	async assignPropertyToStage(obj) {
		return await Api.post('/api/assign-customer-to-stage', obj);
	},
	// Get all customers for matching with current property (admin)
	async getCustomersForMatching(filter) {
		return await Api.post('/api/customers-for-matching', filter);
	},
	async getVerifiedProperties(obj) {
		return await Api.post('/api/verified-properties', obj);
	},
	async sendVerificationEmail(obj) {
		return await Api.post('/api/send-verification-mail', obj);
	},
	async neighborhoodSearch(obj) {
		return await Api.post('/api/property/neighborhood/search', obj);
	},
	async getAssigned(obj) {
		return await Api.post('/api/property/assigned', obj);
	},
	// Check if property with this address already exists
	async checkPropertyAddress(obj) {
		return await Api.post('/api/property/check-address', obj);
	},
	async deleteHistoryRow(obj) {
		return await Api.delete('/api/property/delete-history', { data: { property_id: obj.property_id, history_id: obj.history_id } });
	}
};
